import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";
import {
  getOnewayStyleClick,
  getOnewayStyleHover,
  getOnewayNoArrowsStyleClick,
  getOnewayNoArrowsStyleHover,
} from "../style/oneway";

export function getOnewayInteractions(layer, control) {
  return buildInteractions(
    layer,
    control,
    getOnewayStyleClick,
    getOnewayStyleHover,
  );
}

export function getOnewayNoArrowsInteractions(layer, control) {
  return buildInteractions(
    layer,
    control,
    getOnewayNoArrowsStyleClick,
    getOnewayNoArrowsStyleHover,
  );
}

function buildInteractions(layer, control, clickStyle, hoverStyle) {
  const clickSelect = new Select({
    layers: [layer],
    condition: click,
    style: function (feature) {
      return clickStyle(feature);
    },
  });
  clickSelect.on("select", function (e) {
    if (e.target.getFeatures().getLength() > 0) {
      control.set(
        "selectedFeatures",
        Array.from(e.target.getFeatures().getArray()),
      ); // create new array so that the event gets triggered
    } else {
      control.set("selectedFeatures", undefined);
    }
  });
  return [
    clickSelect,
    new Select({
      layers: [layer],
      condition: pointerMove,
      style: function (feature) {
        return hoverStyle(feature);
      },
    }),
  ];
}
